// Figma: signup-request-submitted (node 18050:579). Shown after updateSignUpSession
// succeeds. Note: LC2's old Register.js also branched on renter/operator checkboxes
// (dispatch(setupResident(true)) for renters, skipping the email mutation entirely) —
// that choice isn't represented anywhere in these Figma frames, so it's dropped here.
// Flag for design follow-up if renter/operator still needs its own step.
import React from 'react';
import PropTypes from 'prop-types';
import StatusCard from './components/StatusCard';
import checkmarkIcon from '../../assets/auth/checkmark-icon.svg';
import {tokens} from '../../themes/ThemeCustomization';

const SignupSubmittedCard = ({onBackToLogin}) => (
    <StatusCard
        icon={checkmarkIcon}
        iconBackground={tokens.color.success50}
        title="Request submitted"
        description="Thanks for your interest. If eligible, our team will reach out with next steps."
        secondaryAction={{label: 'Back to login', onClick: onBackToLogin}}
    />
);

SignupSubmittedCard.propTypes = {
    onBackToLogin: PropTypes.func.isRequired
};

export default SignupSubmittedCard;
